import {getBackendUrl} from 'utilities';

/** POST to a backend admin endpoint that isn't in the generated client. */
export async function postAdminJson<T>(path: string): Promise<T> {
  const base = getBackendUrl().replace(/\/+$/, '');
  const res = await fetch(`${base}${path}`, {
    method: 'POST',
    credentials: 'include',
    headers: {'Content-Type': 'application/json'},
  });
  if (!res.ok) {
    const detail = await res.text().catch(() => res.statusText);
    throw new Error(detail || 'Request failed');
  }
  return res.json() as Promise<T>;
}
